import React from 'react';

function PreConditionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.90909 3.09091C6.60785 3.09091 6.36364 3.33512 6.36364 3.63636V5.81818C6.36364 6.11943 6.11943 6.36364 5.81818 6.36364H3.63636C3.33512 6.36364 3.09091 6.60785 3.09091 6.90909V9.09091C3.09091 9.39216 3.33512 9.63636 3.63636 9.63636H5.81818C6.11943 9.63636 6.36364 9.88056 6.36364 10.1818V12.3636C6.36364 12.6649 6.60785 12.9091 6.90909 12.9091H9.09091C9.39216 12.9091 9.63636 12.6649 9.63636 12.3636V10.1818C9.63636 9.88056 9.88056 9.63636 10.1818 9.63636H12.3636C12.6649 9.63636 12.9091 9.39216 12.9091 9.09091V6.90909C12.9091 6.60785 12.6649 6.36364 12.3636 6.36364H10.1818C9.88056 6.36364 9.63636 6.11943 9.63636 5.81818V3.63636C9.63636 3.33512 9.39216 3.09091 9.09091 3.09091H6.90909ZM5.27273 3.63636C5.27273 2.73263 6.00535 2 6.90909 2H9.09091C9.99467 2 10.7273 2.73263 10.7273 3.63636V5.27273H12.3636C13.2674 5.27273 14 6.00535 14 6.90909V9.09091C14 9.99467 13.2674 10.7273 12.3636 10.7273H10.7273V12.3636C10.7273 13.2674 9.99467 14 9.09091 14H6.90909C6.00535 14 5.27273 13.2674 5.27273 12.3636V10.7273H3.63636C2.73263 10.7273 2 9.99467 2 9.09091V6.90909C2 6.00535 2.73263 5.27273 3.63636 5.27273H5.27273V3.63636Z"
        fill="#17385D"
        stroke="#17385D"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export default PreConditionIcon;
